import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { App } from './app';
import './styles/index.css';
import './styles/tailwindcss.v2.css';

Sentry.init({
  // dsn: 'https://e52f984a3d5c136042f710e39bed6186@o4504478126571520.ingest.sentry.io/4506061294731264',
  dsn: 'https://d0baa1e0d3e3fb51d9efdd68eb185a6d@o4504478126571520.ingest.sentry.io/4506031609806848',
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', /^https:\/\/api\.giho\.\.jp\/graphql/],
    }),
    new Sentry.Replay(),
  ],
  environment: import.meta.env.VITE_SENTRY_ENV,
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
